import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";

import {
  AssociationForm,
  AssociationFormValues,
} from "../../components/association-form";
import { H1 } from "../../components/h1";
import { createOwnedAssociation } from "../../services/association";
import { useAuthStore } from "../../stores/auth";
import { useControlAssociationStore } from "../../stores/control-association";
import { useLocale } from "../../stores/locale";

export function ControlAssociationCreate() {
  const { locale, currentLanguage } = useLocale();
  const navigate = useNavigate();
  const { isAuth } = useAuthStore();
  const setSelectedAssociationId = useControlAssociationStore(
    (s) => s.setSelectedAssociationId,
  );

  const [formValues, setFormValues] = useState<AssociationFormValues>({
    name: "",
    domain: "",
    organizationNumber: "",
  });
  const [loading, setLoading] = useState(false);
  const [hasError, setHasError] = useState(false);

  if (!isAuth) {
    return <Navigate replace to="/login" />;
  }

  return (
    <div className="mx-auto flex w-full max-w-xl flex-col gap-6">
      <div className="flex flex-col gap-2">
        <H1>{locale.auth.associationCreateTitle}</H1>
        <Link className="text-sm text-blue-700 hover:underline" to="/start">
          {locale.auth.backToAssociationStart}
        </Link>
      </div>

      <AssociationForm
        hasError={hasError}
        loading={loading}
        submitLabel={locale.auth.controlStartCreateSubmit}
        values={formValues}
        onCancel={() => navigate("/start")}
        onChange={setFormValues}
        onSubmit={() => {
          (async () => {
            setLoading(true);
            setHasError(false);
            try {
              const created = await createOwnedAssociation(
                {
                  name: formValues.name.trim(),
                  domain: formValues.domain.trim(),
                  organizationNumber: formValues.organizationNumber.trim(),
                  primaryLanguage: currentLanguage,
                },
                currentLanguage,
              );
              setSelectedAssociationId(created.id);
              navigate("/admin/users");
            } catch {
              setHasError(true);
            } finally {
              setLoading(false);
            }
          })();
        }}
      />
    </div>
  );
}
